import { SelectFieldCP } from 'modules/fields/components/select-field/SelectFieldCP'
import { SelectLocationCP } from 'common/components/form/SelectLocationCP'
import React from 'react'
import styled from 'styled-components'
import { ButtonCP } from 'submodules/nerit-framework-ui/common/components/button/ButtonCP'
import { DateRangePickerCP } from 'submodules/nerit-framework-ui/common/components/form-fields/date-range-picker/DateRangePickerCP'
import { ColumnCP } from 'submodules/nerit-framework-ui/common/components/grid/column/ColumnCP'
import { RowCP } from 'submodules/nerit-framework-ui/common/components/grid/row/RowCP'
import { IFormStateManager } from 'submodules/nerit-framework-ui/common/form-state-manager/types/IFormStateManager'
import { FlexCP } from 'submodules/nerit-framework-ui/common/components/flex/FlexCP'
import { FlexOneICP } from 'submodules/nerit-framework-ui/common/components/flex/inner/FlexOneICP'
import { LocationCorrelationChartFiltersFormModel } from 'modules/reports/components/filters/filter-location-correlation-chart/inner/LocationCorrelationChartFiltersFormModel'
import { useEnterKeySearch } from 'submodules/nerit-framework-ui/common/responsiveness/use-enter-key-search/UseEnterKeySearch'

interface ICPProps {
    onFilter: () => void
    formStateManager: IFormStateManager<LocationCorrelationChartFiltersFormModel>
    loading?: boolean
}

export function FilterLocationCorrelationChartCP(props: ICPProps): JSX.Element {

    useEnterKeySearch (props.onFilter)

    return (
        <ContentSCP>
            <FlexCP justifyContent={'space-between'} alignItems={'flex-end'}>
                <FlexOneICP marginRight={10}>
                    <RowCP>
                        <ColumnCP size={8}>
                            <SelectLocationCP
                                formStateManager={props.formStateManager}
                                fieldName={'locationCodes'}
                                isRequired={true}
                                isMany={true}
                            />
                        </ColumnCP>
                        <ColumnCP size={8}>
                            <SelectFieldCP
                                formStateManager={props.formStateManager}
                                fieldName={'fieldCode'}
                                isRequired={true}
                            />
                        </ColumnCP>
                        <ColumnCP size={8}>
                            <DateRangePickerCP
                                showBorder={true}
                                marginTop={23}
                                fastFilter={'all'}
                                fieldName={'dateRange'}
                                onChange={(dateRange) => props.formStateManager.changeFieldValue('dateRange', dateRange)}
                                value={props.formStateManager.getFieldValue('dateRange')}
                            />
                        </ColumnCP>
                    </RowCP>
                </FlexOneICP>
                <ButtonCP
                    marginBottom={10}
                    icon={'search'}
                    type={'primary'}
                    onClick={props.onFilter}
                    loading={props.loading}
                />
            </FlexCP>
        </ContentSCP>
    )
}

const ContentSCP = styled.div`
  width: 100%;
  background: #fff;
  padding: 1rem 2rem;
`
